import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Tooltip.scss';
var TooltipSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};
export var TooltipPositions = {
    TOP: 'top',
    TOP_LEFT: 'topLeft',
    TOP_RIGHT: 'topRight',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    BOTTOM_LEFT: 'bottomLeft',
    BOTTOM_RIGHT: 'bottomRight',
    LEFT: 'left'
};
var Tooltip = function (_a) {
    var children = _a.children, className = _a.className, content = _a.content, position = _a.position, size = _a.size, props = __rest(_a, ["children", "className", "content", "position", "size"]);
    var componentClass = classnames('Tooltip', "Tooltip--".concat(position), "Tooltip--".concat(size), className, {
        'Tooltip--hasContent': content
    });
    return (React.createElement("div", __assign({}, props, { className: componentClass }),
        content && React.createElement("div", { className: 'Tooltip__content' }, content),
        React.createElement("div", { className: 'Tooltip__children' }, children)));
};
Tooltip.defaultProps = {
    position: TooltipPositions.TOP,
    size: TooltipSizes.SMALL
};
Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    content: PropTypes.node,
    position: PropTypes.oneOf(Object.values(TooltipPositions)),
    size: PropTypes.oneOf(Object.values(TooltipSizes))
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map